import React, { Fragment } from 'react'
// TODO:
// import { FormattedMessage } from '@dragonraider5/react-intl'
import { SectionTitle, SectionWrapper } from '../../../../components/Section'

function DocumentsWelcome() {
  return (
    <Fragment>
      <SectionTitle data-section='4'>
        Documentos fiscales
      </SectionTitle>
      <SectionWrapper>
        <p>En esta pantalla debes facilitar diferentes documentos fiscales y bancarios. Te solicitaremos que adjuntes información o bien que nos autorices a que nos descarguemos copia de tus declaraciones fiscales mediante la introducción de los códigos de verificación que te ha facilitado la AEAT. Todos estos documentos junto a los que ya nos hayas aportado anteriormente nos permitirán conocer mejor tu organización y evaluar tu solicitud. </p>
        <p>Si en este momento no dispones de toda la documentación, adjunta la que tengas disponible y vuelve a entrar en el área de usuario cuando hayas recopilado el resto. Dispondrás del plazo de 1 mes durante el cuál la información incluida hasta ahora se guardará, para que puedas completar la solicitud.</p>
      </SectionWrapper>
    </Fragment>
  )
}

export default DocumentsWelcome
